// src/features/legacy-reports/useLegacyAccountReport.ts

import { useQuery } from '@tanstack/react-query';
import { LegacyReportsApi } from './LegacyReportsApi';
import { LEGACY_REPORTS_QUERY_KEYS } from '@/lib/constants/legacyReports';
import type { LegacyAccountReport } from './types';

export interface UseLegacyAccountReportResult {
  report: LegacyAccountReport | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/** Legacy account report. Default 5-min staleTime — legacy aggregates change slowly. */
export function useLegacyAccountReport(
  cId: number | null,
  start: number,
  end: number
): UseLegacyAccountReportResult {
  const query = useQuery({
    queryKey: LEGACY_REPORTS_QUERY_KEYS.account(cId ?? 0, start, end),
    queryFn: () => LegacyReportsApi.getAccountReport(cId!, start, end),
    enabled: cId !== null,
  });

  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
